var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.app.icon)?_c('img',{staticStyle:{"height":"40px","margin-right":"10px","border-radius":"5px"},attrs:{"src":_vm.app.icon}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.app.app_name?_vm.app.app_name:('无效应用'+_vm.appId)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103035c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V1/ApplicationShow.vue
// module id = null
// module chunks = 